export default __webpack_public_path__ + "97a98ce56a7db4eaaa1658aba4209512.png";